<template>
    <div>
        <span v-show="enabled">
            <input type="text"  autocomplete="off" class="layui-input layuiyear" readonly="readonly"/>
            <i class="layui-icon layui-icon-date" style="position: absolute;top:calc(50% - 10px);;right: 8px;margin-top: 0px;"></i>
        </span>
        <span v-show="!enabled">
            <input type="text"  autocomplete="off" class="layui-input layui-disabled layuiyear-disabled" readonly="readonly" disabled="disabled"/>
             <i class="layui-icon layui-icon-date" style="position: absolute;top:calc(50% - 10px);;right: 8px;margin-top: 0px;"></i>
        </span>
    </div>
</template>

<script>
export default {
     name: 'LayuiYear',
     _model: {
        default: '',
        required: false
    },
    props: {
        placeholder: {
            default: '',
            type: String
        },
        _model: {
            default: '',
            required: false
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        min: {
            type: String | Function,
        },
        max: {
            type: String | Function,
        }
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data: function(){
        return {
        }
     },
     mounted(){
        var id = this.id = 'layuiyear' + this.uuid();
        var element = this.el = $(this.$el);
        if(this.placeholder) {
            element.find('.layuiyear').attr('placeholder', this.placeholder);
        }
        element.find('.layuiyear').attr('id', this.id);
        var min = '1900-01-01';
        var max = '2050-12-31';
        if(this.min) {
            if(typeof this.min == 'string') {
                min = this.min;
            } else {
                min = this.min();
            }
        }
        if(this.max) {
            if(typeof this.max == 'string') {
                max = this.max;
            } else {
                max = this.max();
            }
        }
        this.layui.laydate.render({
            elem: '#' + this.id,
            type: 'year',
            min : min,
            max : max,
            done: (value, date) => {
                this.$emit('_modelEvent', value);
                this.$emit('change', value);
            }
        });
    },
    methods: {
        select(value) {
            if(value) {
                value = value + '';
                var v = value.split(' ');
                v = v.length > 0 ? v[0] : value;
                this.el.find('.layuiyear,.layuiyear-disabled').val(v);
            }
           
        },
        handleEnabled() {
             if (this.enabled) {
                 // 显示日期组件
             } else {
                 // 显示input框
             }
        }
    },
    watch:{
        _model(value){
           this.select(value);
        },
         enabled() {
            this.handleEnabled();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiYear.vue